<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Usuarios</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="content">
    <ion-list>
      <ion-item-sliding v-for="u in usuarios" :key="u._id">
        <ion-item v-on:click="ver(u)">
          <ion-note slot="start">
            <i class="icon ion-ios-cog icon-lg" v-if="u.rol=='administrador'"></i>
            <i class="icon ion-ios-contact icon-lg" v-else></i>
          </ion-note>
          <ion-label text-wrap>
            <h2>{{u.nombre}}</h2>
            <p>{{u.rol}}</p>
            <p>{{u.email}}</p>
          </ion-label>
          <!--ion-note slot="end">{{u.email}}</ion-note-->
        </ion-item>
        <ion-item-options slot="end">
          <ion-item-option color="danger" @click="eliminar(u)">
            <i class="icon ion-ios-trash"></i>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="ver({})">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'CatalogoUsuarios',
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      usuarios: [{
        nombre: 'Administrador',
        rol: 'administrador',
        email: 'admin@local'
      }, {
        nombre: 'Usuario de campo 1',
        rol: 'operador',
        email: 'operador@local'
      }, {
        nombre: 'Usuario de campo 2',
        rol: 'operador',
        email: 'operador2@local'
      }]
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    ver(u) {
      //if (false) {
      if (this.yo.permiso_editaUsuarios || this.yo.rol == 'administrador') {
        console.log("Ver", u)
        toast("Viendo: " + (u.nombre || 'Nuevo usuario'))
        this.$router.push('/catalogos/usuarios/' + (u._id || '0'))
      }
      //}
      else
        toast("Sin permisos suficientes")
    },
    async obtener() {
      this.usuarios = (await Api.get('directorio'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      console.log("Usuarios", this.usuarios.length)
    },
    async eliminar(u) {
      if (true == confirm('Desea eliminar al usuario ' + u.nombre + '?')) {
        await Api.delete('directorio', u._id)
        toast("Eliminado")
        await Api.wait(1000)
        this.obtener()
      }
    }
  },
  mounted() {
    this.obtener()
  }
}
</script>
